import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import intl from 'react-intl-universal'
import StudyField from 'components/search/StudyField'
import { DropdownMenu, BoxedLink } from 'components/qstrap'
import { Dropdown, DropdownToggle } from 'reactstrap'
import Accordion from 'components/molecules/Accordion'
import storage from 'utils/storage'
import buildUrl from 'utils/buildUrl'
import isDOMAvailable from 'utils/isDOMAvailable'

const propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  studyFields: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func,
  selectedLocation: PropTypes.string,
  selectedStudyField: PropTypes.string,
  fixedNavbar: PropTypes.bool,
  navbarHeight: PropTypes.string,
  bannerHeight: PropTypes.string,
}

class Filters extends React.Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.setFilter = this.setFilter.bind(this)

    const { selectedLocation, selectedStudyField } = this.props

    this.state = {
      locationOpen: false,
      studyFieldOpen: false,
      location: selectedLocation,
      studyField: selectedStudyField,
      sticky: false,
    }
  }

  componentDidMount() {
    if (isDOMAvailable) {
      window.addEventListener('scroll', this.toggleSticky)
    }
  }

  setFilter(value) {
    this.setState(value, () => {
      const {
        locationId, studyFieldId, studyField, location,
      } = this.state

      const newLocation = (locationId && locationId !== 'all') ? location : undefined
      const newStudyField = (studyFieldId && studyFieldId !== 'all') ? studyField : undefined
      const paramsStorage = storage.get('serverProps', 'params')

      if (!paramsStorage) storage.set(['serverProps', 'params'], {})
      storage.select(['serverProps', 'params']).deepMerge({
        location: newLocation,
        study_field: newStudyField,
      })

      this.props.onChange({
        locationId,
        studyFieldId,
      })

      buildUrl({
        path: 'directory',
        queryParams: {
          study_field: newStudyField,
          location: newLocation,
        },
      })
    })
    this.toggle(Object.keys(value)[0])
  }

  toggleSticky = () => {
    const { sticky } = this.state

    if (window.scrollY >= (this.props.bannerHeight + this.props.navbarHeight)) {
      !sticky && this.setState({ sticky: true })
    } else {
      sticky && this.setState({ sticky: false })
    }
  }

  toggle(filter) {
    const key = `${filter}Open`
    const newState = {}
    newState[key] = !this.state[key]
    this.setState(newState)
  }

  render() {
    const { fixedNavbar, navbarHeight, locations, studyFields } = this.props
    const { sticky } = this.state
    const classNameVal = classnames('search-filters', {
      'search-filters--sticky': sticky && fixedNavbar,
    })
    return (
      <div id="search-filters" className={classNameVal}>
        <div className="text-center">
          <Dropdown isOpen={this.state.locationOpen} toggle={() => this.toggle('location')}>
            <DropdownToggle caret>
              {this.props.selectedLocation}
            </DropdownToggle>
            <DropdownMenu className="boxed-link-container">
              <a onClick={() => this.setFilter({ location: intl.get('search.filters.all_locations'), locationId: 'all' })}>
                <BoxedLink color="white" svgIcon="next" name={intl.get('search.filters.all_locations')} />
              </a>
              {locations.map(location => (
                <a key={location.id} onClick={() => this.setFilter({ location: location.name, locationId: location.id })}>
                  <BoxedLink color="white" svgIcon="next" name={location.name} />
                </a>
              ))}
            </DropdownMenu>
          </Dropdown>

          <Dropdown isOpen={this.state.studyFieldOpen} toggle={() => this.toggle('studyField')}>
            <DropdownToggle caret>
              {this.props.selectedStudyField}
            </DropdownToggle>
            <DropdownMenu className="boxed-link-container">
              <a onClick={() => this.setFilter({ studyField: intl.get('search.filters.all_fields_of_study'), studyFieldId: 'all' })}>
                <BoxedLink color="white" svgIcon="next" name={intl.get('search.filters.all_fields_of_study')} />
              </a>
              <Accordion startPosition={-1}>
                {studyFields.map(studyField => (
                  <div data-trigger={<StudyField name={studyField.name} childCount={studyField.children.length} />} key={studyField.name}>
                    <div className="list-group m-a-0">
                      {studyField.children.map(child => (
                        <a key={child.id} onClick={() => this.setFilter({ studyField: child.name, studyFieldId: child.id })}>
                          <BoxedLink color="white" svgIcon="next" name={child.name} />
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
              </Accordion>
            </DropdownMenu>
          </Dropdown>
        </div>
        <style jsx>
          {`
            .search-filters {
              &--sticky {
                position: fixed;
                z-index: 2;
                top: ${fixedNavbar ? `${navbarHeight - 1}px` : 0};
                width: 100%;
              }
            }
          `}
        </style>
      </div>
    )
  }
}

Filters.propTypes = propTypes

export default Filters
